import * as React from "react";
import { FeedItemNewUser } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";

export const FeedElementNewUser = ({ item }: { item: FeedItemNewUser }) => {
  return (
    <FeedElementContainer
      href={`/user/${item.user.username}`}
      compact
      avatars={[item.user]}
      icon={"user"}
      title={
        <>
          <LinkToUser linkUser={{ username: item.user.username }} />
          <span className="text-slate-500 dark:text-slate-400"> just signed up!</span>
        </>
      }
    ></FeedElementContainer>
  );
};
